// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__ypvcn","footer":"ModalFilter_footer__1xQf3"};